export const getCookie = (name: string) => {
  const cookie = `${name}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]

    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }

    if (c.indexOf(cookie) === 0) {
      return c.substring(cookie.length, c.length)
    }
  }

  return ''
}

export const setCookie = (name: string, value: string, path?: string) => {
  const pathSetting = path !== undefined ? `;path=${path}` : ''
  document.cookie = `${name}=${value}${pathSetting}`
}
